import React, { useState, useRef, useEffect } from "react";
import { Routes } from "../../constants";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { injectModels } from "../../redux/injectModels";
import MergeVideosDND from "./MergeVideosDND";
import ReactPaginate from "react-paginate";
import { AiFillLeftCircle, AiFillRightCircle } from "react-icons/ai"; // icons form react-icons
import { IconContext } from "react-icons";
import Swal from "sweetalert2";

const MergeVideos = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [videoPreviewModal, setVideoPreviewModal] = useState(null);
  const [finalvideoPreviewModal, setFinalVideoPreviewModal] = useState(null);
  const [showFinalVideoPreview, setShowFinalVideoPreview] = useState(false);
  const [showVideoPreview, setShowVideoPreview] = useState(false);
  const video_session_id = location?.state?.video_session_id;
  const card = location?.state?.cards;
  const filteredCards = (card || []).filter((item) => item.videoId !== null);
  const [duration, setDuration] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [data, setData] = useState(null); // from API
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [mergeList, setMergeList] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [showPreviousButton, setShowPreviousButton] = useState(false);
  const [showNextButton, setShowNextButton] = useState(true);
  const [mergeRequestId, setMergeRequestId] = useState("");
  const [imagePreview, setImagePreview] = useState();
  const [refreshLoader,setRefreshLoader]=useState(false);
  const rowsPerPage = 5;
  const offset = currentPage * rowsPerPage;
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [options, setOptions] = useState({
    noise: false,
    silence: false,
    audio: false,
    compress: true,
    speed: false,
    repetition_removal:false,
  });

  let paginatedData = [];
  try {
    if (Array.isArray(mergeList)) {
      paginatedData = mergeList.slice(offset, offset + rowsPerPage);
    } else {
      throw new Error("filteredData is not an array");
    }
  } catch (exception) {
    paginatedData = [];
    console.log(exception);
  }
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    if (selected === 0) {
      setShowPreviousButton(false);
    } else {
      setShowPreviousButton(true);
    }
    const pageCount = Math.ceil(mergeList.length / rowsPerPage);
    if (selected === pageCount - 1 || pageCount === 1) {
      setShowNextButton(false);
    } else {
      setShowNextButton(true);
    }
  };
  const renderPagination = () => {
    const pageCount = Math.ceil(mergeList.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          pageClassName={"page-item"}
          pageCount={pageCount}
          pageRangeDisplayed={0}
          marginPagesDisplayed={2}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          containerClassName="pagination"
          activeClassName="active"
          breakLabel="..."
          previousLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillLeftCircle />
            </IconContext.Provider>
          }
          nextLabel={
            <IconContext.Provider value={{ color: "#B8C1CC", size: "36px" }}>
              <AiFillRightCircle />
            </IconContext.Provider>
          }
          renderOnZeroPageCount={null}
          disableInitialCallback={true}
        />
      );
    }
    return null;
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    const delayedHandler = (e) => {
      requestAnimationFrame(() => handleClickOutside(e));
    };

    document.addEventListener("mousedown", delayedHandler);

    return () => {
      document.removeEventListener("mousedown", delayedHandler);
    };
  }, []);

  useEffect(() => {
    fetchVideos();
    fetchDuration();
  }, []);

  const handleFinalVideoPreview = (url) => {
    setFinalVideoPreviewModal(url);
    setShowFinalVideoPreview(true);
    toast.dismiss();
    toast({
      title: "Video Preview",
      description: "Opening video preview...",
    });
  };
  const handleFinalcloseModel = () => {
    setShowFinalVideoPreview(false);
  };
  const handleCheckboxUploadChange = (e) => {
    const { name, checked } = e.target;
    setOptions((prev) => ({ ...prev, [name]: checked }));
  };
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedFiles(files);
  };

  const fetchVideos = async () => {
    try {
      props.application.setLoading(true);
      
      const response = await props.admin.getAllMergeVideo(video_session_id);

      if (response.success && response.data) {
        setData(response.data);
        const initialVideos = response?.data?.items.map((v) => ({
          ...v,
          location: "A",
        }));
        setVideos(initialVideos);
        const generatedVideoIds = response.data.items
          .filter((item) => item.type === "generated")
          .map((item) => item.video_generation_id);
        setSelectedVideos(generatedVideoIds);
        await listMerge(response.data.merge_request_id);
        setMergeRequestId(response.data.merge_request_id);
      } else {
        setData(null);
        setVideos([]);
      }
    } catch (error) {
      console.error("Error fetching videos:", error);
      toast.dismiss();
      toast.error("Something went wrong while fetching videos.", {
        position: toast.POSITION.TOP_CENTER,
      });
      setVideos([]);
    } finally {
      props.application.setLoading(false);
  
    }
  };
  const fetchDuration = async () => {
    try {
      props.application.setLoading(true);

      const response = await props.admin.getDuration(video_session_id);

      if (response.success && response.data) {
        setDuration(response.data);
      } else {
        setDuration("");
      }
    } catch (error) {
      setDuration("");
      console.error("Error fetching duration:", error);
      toast.dismiss();
      toast.error("Something went wrong while fetching .", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      props.application.setLoading(false);
    }
  };

  const listMerge = async () => {
    try {
      props.application.setLoading(true);

      const response = await props.admin.MergeVideolist(video_session_id);
      if (response.success) {
        setMergeList(response.records);
      } else {
        setMergeList([]);
      }
    } catch (error) {
      console.error("Error fetching list:", error);
      toast.dismiss();
      toast.error("Something went wrong while fetching list.", {
        position: toast.POSITION.TOP_CENTER,
      });
      setMergeList([]);
    } finally {
      props.application.setLoading(false);
    }
  };

  const handlebackPage = () => {
    navigate(Routes.CREATE_VIDEO_Sop, { state: video_session_id });
  };

  const handleVideoCloseModel = () => {
    setShowVideoPreview(false);
  };

  const handleVideoPreview = (itemId) => {
    const item = videos.find((i) => i.sequence === itemId);
    if (item && item.video_url) {
      setVideoPreviewModal(item.video_url);
      setShowVideoPreview(true);
      toast.dismiss();
      toast({
        title: "Video Preview",
        description: "Opening video preview...",
      });
    }
  };
  const handleCheckboxChange = (id) => {
    setSelectedIds(
      (prev) =>
        prev.includes(id)
          ? prev.filter((item) => item !== id) // remove if already selected
          : [...prev, id] // add if not selected
    );
  };
  const handleSelectAll = () => {
    if (selectedIds.length === mergeList.length) {
      setSelectedIds([]); // unselect all
    } else {
      setSelectedIds(mergeList.map((item) => item.input_id)); // select all
    }
  };
  const handleReGenerate = async (id) => {
    try {
      props.application.setLoading(true);

      const response = await props.admin.generateVideo(id);
      if (response.success) {
        listMerge();
      }
    } catch (error) {
      console.error("Error fetching list:", error);
      toast.dismiss();
      toast.error("Something went wrong while fetching list.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      props.application.setLoading(false);
    }
  };
  // const handleVideoUpload = () => {
  //   const input = document.createElement("input");
  //   input.type = "file";
  //   input.accept = "video/mp4"; // MP4 only
  //   input.multiple = true;

  //   input.onchange = async (e) => {
  //     const files = e.target.files;

  //     if (files && files.length > 0) {
  //       const validFiles = [];
  //       const invalidFiles = [];

  //       // ✅ Validate each file before sending
  //       await Promise.all(
  //         Array.from(files).map(
  //           (file) =>
  //             new Promise((resolve) => {
  //               if (!file.type.startsWith("video/")) {
  //                 invalidFiles.push(file.name);
  //                 return resolve();
  //               }

  //               const video = document.createElement("video");
  //               video.preload = "metadata";

  //               video.onloadedmetadata = () => {
  //                 validFiles.push(file);
  //                 resolve();
  //               };

  //               video.onerror = () => {
  //                 invalidFiles.push(file.name);
  //                 resolve();
  //               };

  //               video.src = URL.createObjectURL(file);
  //             })
  //         )
  //       );

  //       // ❌ If any invalid files → block upload
  //       if (invalidFiles.length > 0) {
  //         toast.error(
  //           invalidFiles.length === 1
  //             ? ` The file "${invalidFiles[0]}" is not valid. Please choose again.`
  //             : ` These files are not valid: ${invalidFiles.join(
  //                 ", "
  //               )}. Please choose again.`,
  //           {
  //             position: toast.POSITION.TOP_CENTER,
  //             autoClose: 6000,
  //           }
  //         );
  //         return; // 🚫 stop upload
  //       }

  //       // ✅ If all files are valid → proceed with upload
  //       const formData = new FormData();
  //       formData.append("session_id", video_session_id);
  //       validFiles.forEach((file) => formData.append("uploaded_files", file));

  //       try {
  //         props.application.setLoading(true);
  //         const response = await props.admin.uploadVideo(
  //           formData,
  //           video_session_id
  //         );

  //         if (response.success) {
  //           const { uploaded_results } = response.data;
  //           toast.dismiss();

  //           if (uploaded_results && uploaded_results.length > 0) {
  //             toast.success(
  //               "Videos uploaded successfully!",

  //               {
  //                 position: toast.POSITION.TOP_CENTER,
  //                 autoClose: 5000,
  //               }
  //             );
  //           }

  //           await fetchVideos();
  //           props.application.setLoading(false);
  //         } else {
  //           toast.error(response.message, {
  //             position: toast.POSITION.TOP_CENTER,
  //             autoClose: 5000,
  //           });
  //           props.application.setLoading(false);
  //         }
  //       } catch (error) {
  //         console.error("Upload failed:", error);
  //         toast.dismiss();
  //         toast.error("Failed to upload videos. Please try again.", {
  //           position: toast.POSITION.TOP_CENTER,
  //         });
  //         props.application.setLoading(false);
  //       }
  //     }
  //   };

  //   input.click();
  // };

  const handleDownloadZip = async () => {
    try {
      if (!mergeRequestId) {
        toast.error("Merge request ID not found!");
        return;
      }
      props.application.setLoading(true);
      console.log("Download these IDs:", selectedIds);

      const apiUrl = `${process.env.REACT_APP_API_ENDPOINT}/video_enhancement/download-all-preprocessed-videos/${video_session_id}?video_ids=${selectedIds}`;

      // ✅ Hit API with fetch
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/zip",
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to download: ${response.statusText}`);
      }
      const url = response.url;

      // ✅ Create a temporary link and click it to download
      const a = document.createElement("a");
      a.href = url;
      a.download = `merged_videos_${mergeRequestId}.zip`;
      document.body.appendChild(a);
      a.click();

      // ✅ Clean up
      a.remove();
      window.URL.revokeObjectURL(url);

      toast.dismiss();
      toast.success("All merged videos downloaded successfully!", {
        position: toast.POSITION.TOP_CENTER,
      });
    } catch (error) {
      console.error("Download failed:", error);
      toast.dismiss();
      toast.error("Failed to download merged videos. Please try again.", {
        position: toast.POSITION.TOP_CENTER,
      });
    } finally {
      props.application.setLoading(false);
    }
  };

  const handleDeleteVideoSession = async (id) => {
    Swal.fire({
      title: "Confirmation",
      text: "Are you sure you want to delete?",
      showCancelButton: true,
      confirmButtonColor: "#009462",
      cancelButtonColor: "#314a5f",
      confirmButtonText: `Yes`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          props.application.setLoading(true);
          const res = await props.admin.deleteMergeList(id);
          if (res.success === true) {
            toast.dismiss();
            toast.success(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
            listMerge();
            props.application.setLoading(false);
          } else {
            props.application.setLoading(false);
            toast.dismiss();
            toast.error(res.message, {
              position: toast.POSITION.TOP_CENTER,
            });
          }
        } catch (error) {
          console.log(error);
          props.application.setLoading(false);
          toast.dismiss();
          toast.error("Something went wrong!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      }
    });
  };
  const resetUploadModal = () => {
    setShowUploadModal(false);

    // reset files
    setSelectedFiles([]);

    // reset checkboxes to default (ALL ON)
    setOptions({
      noise: false,
      silence: false,
      audio: false,
      compress: true,
      speed: false,
      repetition_removal:false,
    });

   

    // reset loader state
    setUploading(false);
  };
  // const handleVideoUpload = () => {
  //   const input = document.createElement("input");
  //   input.type = "file";
  //   input.accept = "video/mp4";
  //   input.multiple = true;

  //   input.onchange = async (e) => {
  //     const files = e.target.files;
  //     if (!files || files.length === 0) return;

  //     const validFiles = [];
  //     const invalidFiles = [];

  //     await Promise.all(
  //       Array.from(files).map(
  //         (file) =>
  //           new Promise((resolve) => {
  //             if (!file.type.startsWith("video/")) {
  //               invalidFiles.push(file.name);
  //               return resolve();
  //             }

  //             const video = document.createElement("video");
  //             video.preload = "metadata";

  //             video.onloadedmetadata = () => {
  //               validFiles.push(file);
  //               resolve();
  //             };

  //             video.onerror = () => {
  //               invalidFiles.push(file.name);
  //               resolve();
  //             };

  //             video.src = URL.createObjectURL(file);
  //           })
  //       )
  //     );

  //     if (invalidFiles.length > 0) {
  //       toast.error(`Invalid files: ${invalidFiles.join(", ")}`);
  //       return;
  //     }

  //     const formData = new FormData();
  //     formData.append("session_id", video_session_id);

  //     // ✅ Add checkbox values
  //     formData.append("noise", options.noise);
  //     formData.append("silence", options.silence);
  //     formData.append("audio", options.audio);
  //     formData.append("compress", options.compress);
  //     formData.append("speed", options.speed);

  //     // ✅ Add videos
  //     validFiles.forEach((file) =>
  //       formData.append("uploaded_files", file)
  //     );

  //     try {
  //       props.application.setLoading(true);
  //       const response = await props.admin.uploadVideo(
  //         formData,
  //         video_session_id
  //       );

  //       if (response.success) {
  //         toast.success("Videos uploaded successfully!");
  //         setOptions({
  //           noise: true,
  //           silence: true,
  //           audio: true,
  //           compress: true,
  //           speed: true,
  //         });
  //         setShowUploadModal(false);
  //         fetchVideos();
  //       } else {
  //         toast.error(response.message);
  //       }
  //     } catch (error) {
  //       toast.error("Upload failed. Please try again.");
  //     } finally {
  //       props.application.setLoading(false);
  //     }
  //   };

  //   input.click();
  // };
  const handleVideoUpload = async () => {
    if (selectedFiles.length === 0) return;

    const formData = new FormData();
    formData.append("session_id", video_session_id);

    // ✅ checkbox params
    Object.keys(options).forEach((key) => {
      formData.append(key, options[key] ? "true" : "false");
    });

    // ✅ files
    selectedFiles.forEach((file) => formData.append("uploaded_files", file));

    try {
      setUploading(true);
      props.application.setLoading(true);

      const response = await props.admin.uploadVideo(
        formData,
        video_session_id
      );

      if (response.success) {
        toast.success("Videos uploaded successfully!");
        resetUploadModal();
        fetchVideos();
        fetchDuration();
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error("Upload failed. Please try again.");
    } finally {
      setUploading(false);
      props.application.setLoading(false);
    }
  };

  return (
    <main id="main" className="main">
      <div className="pagetitle mb-3">
        <h1>Video Merger</h1>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <button
                onClick={handlebackPage}
                style={{ border: "none", color: "#8b8b8b", background: "none" }}
              >
                Generate Video
              </button>
            </li>
            <li className="breadcrumb-item active">Video Merger</li>
          </ol>
        </nav>
      </div>
      <section className="section dashboard meregevideosdata">
        <div className="row">
          <div className="col-md-12">
            <div className="card recent-sales overflow-auto">
              <div className="card-body p-3">
                <div className="data-se">
                  <div className="mergeHeader " ref={dropdownRef}>
                    <div className="mergebutton">
                      <button
                        className="btn btn-primary "
                        // onClick={() => handleVideoUpload()}
                        onClick={() => setShowUploadModal(true)}
                      >
                        <i class="fa-solid fa-upload"></i> Upload video
                      </button>
                      <button
                        onClick={handlebackPage}
                        className="btn btn-primary "
                      >
                        Back
                      </button>
                      <button
                          className="btn btn-primary "
                          onClick={async () => {
                            setRefreshLoader(true);
                            await fetchVideos();
                            await fetchDuration();
                            setTimeout(async () => {
                              setRefreshLoader(false);
                            }, 1000);
                          }}
                          title="Refresh the page"
                        >
                          {" "}
                          {refreshLoader ? (
                            <>
                              <i className="fa-solid fa-spinner fa-spin"></i>{" "}
                            </>
                          ) : (
                            <>
                              <i className="fa-solid fa-rotate-right"></i>
                            </>
                          )}
                        </button>
                    </div>
                    <div className="duration-card">
                      <div className="card-ai">
                        <h3>
                          <i className="fa-regular fa-clock" />
                        </h3>
                        <p>Duration</p>
                      </div>
                      <div className="card-ai">
                        <h3>{duration.ai_generated_duration} :</h3>
                        <p>AI Video</p>
                      </div>
                      <div className="card-ai">
                        <h3>{duration.uploaded_video_duration} :</h3>
                        <p>Uploaded video</p>
                      </div>
                    </div>
                  </div>
                  <MergeVideosDND
                    videos={videos}
                    setVideos={setVideos}
                    props={props}
                    fetchVideos={fetchVideos}
                    videosSessionId={video_session_id}
                    mergeList={mergeList}
                    fetchDuration={fetchDuration}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="tab-content mergetable" id="myTabContent">
          {paginatedData.length > 1 && (
            <div className="mergebutton">
              <button
                className="btn btn-primary mb-3 "
                onClick={() => handleDownloadZip()}
              >
                <i className="fa-solid fa-download" /> Download all
              </button>
            </div>
          )}
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            aria-labelledby="home-tab"
          >
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>
                    {/* <input type="checkbox" checked={
          paginatedData.length > 0 &&
          selectedIds.length === paginatedData.length
        }
        onChange={handleSelectAll}
      /> */}
                    <label className="custom-checkbox">
                      <input
                        type="checkbox"
                        checked={
                          paginatedData.length > 0 &&
                          selectedIds.length === mergeList.length
                        }
                        onChange={handleSelectAll}
                      />
                      <span />
                    </label>
                  </th>

                  <th>Step Number</th>
                  <th>Heading</th>
                  <th>Department</th>
                  <th>Function</th>
                  <th>Date</th>
                  <th>Status</th>
                  <th>Image</th>
                  <th>Video</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  paginatedData.map((item) => (
                    <tr key={item.input_id}>
                      <td style={{ textAlign: "center" }}>
                        <label className="custom-checkbox">
                          <input
                            type="checkbox"
                            checked={selectedIds.includes(item.input_id)}
                            onChange={() => handleCheckboxChange(item.input_id)}
                          />
                          <span />
                        </label>
                      </td>
                      {/* <td>{item.final_video_name.replace(/\.mp4$/, "")}</td> */}
                      <td>{item.step_number}</td>
                      <td>{item.heading}</td>
                      <td>{item.department}</td>
                      <td>{item.function}</td>
                      <td>{item.created_at}</td>
                      <td>
                        {item.progress === "Pending" ? (
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-primary"
                          >
                            Processing...
                          </button>
                        ) : item.progress === "Completed" ? (
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-success"
                          >
                            Done
                          </button>
                        ) : item.progress === "Failed" ? (
                          <button
                            type="button"
                            class="btn btn-sm btn-outline-danger"
                            onClick={() => handleReGenerate(item.input_id)}
                          >
                            Failed
                          </button>
                        ) : (
                          ""
                        )}
                      </td>
                      {item.progress === "Pending" ? (
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={async () => await listMerge()}
                          >
                            <i className="fa-solid fa-rotate-right"></i> Reload{" "}
                          </button>
                        </td>
                      ) : (
                        <td>
                          <button
                            onClick={() => {
                              handleFinalVideoPreview(item);
                              setImagePreview(true);
                            }}
                            className="btn btn-primary btn-sm"
                            disabled={item.progress === "Failed"}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </button>
                          <Link to={item?.paths?.download_image_url}>
                            <button
                              className="btn btn-primary btn-sm"
                              href={item?.paths?.download_image_url}
                              download
                              disabled={item.progress === "Failed"}
                            >
                              <i className="fa-solid fa-download"></i>
                            </button>
                          </Link>{" "}
                        </td>
                      )}
                      {item.progress === "Pending" ? (
                        <td>
                          <button
                            className="btn btn-primary btn-sm"
                            onClick={async () => await listMerge()}
                          >
                            <i className="fa-solid fa-rotate-right"></i> Reload{" "}
                          </button>
                        </td>
                      ) : (
                        <td>
                          <button
                            onClick={() => {
                              handleFinalVideoPreview(item);
                              setImagePreview(false);
                            }}
                            className="btn btn-primary btn-sm"
                            disabled={item.progress === "Failed"}
                          >
                            <i className="fa-solid fa-eye"></i>
                          </button>
                          <Link to={item?.paths?.download_video_url}>
                            <button
                              className="btn btn-primary btn-sm"
                              href={item?.paths?.download_video_url}
                              download
                              disabled={item.progress === "Failed"}
                            >
                              <i className="fa-solid fa-download"></i>
                            </button>
                          </Link>{" "}
                        </td>
                      )}
                      <td>
                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() =>
                            handleDeleteVideoSession(item.input_id)
                          }
                        >
                          <i className="bi bi-trash-fill"></i>
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No results found!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            {
              <div className="table-footer">
                <strong>Total Count: {mergeList.length}</strong>
                {renderPagination()}
              </div>
            }
          </div>
        </div>
      </section>

      {videoPreviewModal && (
        <Modal
          show={showVideoPreview}
          onHide={handleVideoCloseModel}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Video</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <video style={{ width: "100%" }} controls preload="auto">
              <source src={videoPreviewModal} />
            </video>
          </Modal.Body>
        </Modal>
      )}
      {showFinalVideoPreview && (
        <Modal
          show={showFinalVideoPreview}
          onHide={handleFinalcloseModel}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {finalvideoPreviewModal?.step_number}{" "}
              {finalvideoPreviewModal?.heading}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {imagePreview ? (
              <img
                src={finalvideoPreviewModal?.paths?.view_image_url}
                alt="Preview"
                style={{ width: "100%" }}
              />
            ) : (
              <video style={{ width: "100%" }} controls preload="auto">
                <source src={finalvideoPreviewModal?.paths?.view_video_url} />
              </video>
            )}
          </Modal.Body>
        </Modal>
      )}

      {showUploadModal && (
        <Modal
          show={showUploadModal}
          onHide={resetUploadModal}
          size="md"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Upload Video with Processing Options</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* File input */}
            <input
              type="file"
              accept="video/mp4"
              multiple
              className="form-control mb-3"
              onChange={handleFileChange}
            />

            {/* Selected file names */}
            {selectedFiles.length > 0 && (
              <ul className="mt-2 small text-muted">
                {selectedFiles.map((file, i) => (
                  <li key={i}>{file.name}</li>
                ))}
              </ul>
            )}

            {/* <hr/> */}
            {/* Checkboxes */}
            <div className="addedcheck">
              {[
                { label: "Noise Reduction", name: "noise" },
                { label: "Silence Removal", name: "silence" },
                { label: "Increase Playback Speed", name: "speed" },
                { label: "Video Compression", name: "compress" },
                { label: "Volume Boost", name: "audio" },
                {label:"Repetition Removal", name:"repetition_removal"}
              ].map((item) => (
                <div className="form-check mb-2" key={item.name}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name={item.name}
                    checked={options[item.name]}
                    onChange={handleCheckboxUploadChange}
                  />
                  <label className="form-check-label">{item.label}</label>
                </div>
              ))}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              className="btn btn-secondary"
              onClick={resetUploadModal}
              disabled={uploading}
            >
              Cancel
            </button>

            <button
              className="btn btn-primary"
              onClick={handleVideoUpload}
              disabled={selectedFiles.length === 0 || uploading}
            >
              {uploading ? "Uploading..." : "Upload"}
            </button>
          </Modal.Footer>
        </Modal>
      )}
    </main>
  );
};

export default injectModels(["admin", "application", "application"])(
  MergeVideos
);
